import React from 'react';
import { Card } from 'primereact/card';
import { ProgressSpinner } from 'primereact/progressspinner';
import './dashboard.css';

const SummaryCards = ({ data }) => {
    if (!data) {
        return <ProgressSpinner />;
    }

    const cards = [
        {
            title: 'Total Loan Amount',
            value: `₹${data.totalLoanAmount.toLocaleString()}`,
            icon: 'pi pi-money-bill',
            color: 'primary',
            change: '+12%'
        },
        {
            title: 'Total Outstanding',
            value: `₹${data.totalOutstanding.toLocaleString()}`,
            icon: 'pi pi-briefcase',
            color: 'warning',
            change: '+5%'
        },
        {
            title: 'Active Loans',
            value: data.totalActiveLoans,
            icon: 'pi pi-th-large',
            color: 'success',
            change: '+3%'
        },
        {
            title: 'Total Members',
            value: data.totalMembers,
            icon: 'pi pi-users',
            color: 'info',
            change: '+8%'
        },
        {
            title: 'Gold Weight (g)',
            value: data.totalGoldWeight.toFixed(2),
            icon: 'pi pi-flag',
            color: 'gold',
            change: '+2%'
        },
        {
            title: 'Avg LTV Ratio',
            value: `${data.averageLTV.toFixed(2)}%`,
            icon: 'pi pi-chart-line',
            color: 'secondary',
            change: '+1%'
        }
    ];

    return (
        <div className="summary-cards">
            {cards.map((card, index) => (
                <div key={index} className="summary-card">
                    <Card>
                        <div className="summary-card-content">
                            <div className="summary-card-icon">
                                <i className={card.icon}></i>
                            </div>
                            <div className="summary-card-info">
                                <h3>{card.value}</h3>
                                <span className="summary-card-title">{card.title}</span>
                            </div>
                            <div className={`summary-card-change ${card.change.includes('+') ? 'positive' : 'negative'}`}>
                                {card.change}
                            </div>
                        </div>
                    </Card>
                </div>
            ))}
        </div>
    );
};

export default SummaryCards;